import LogoCyberSource from '@/modules/perseo-billing/assets/images/logo-cybersource.png';
import LogoGlobalSign from '@/modules/perseo-billing/assets/images/logo-global-sign.png';
import LogoSSL from '@/modules/perseo-billing/assets/images/logo-ssl.png';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';

export const SafePurchase = () => {
  return (
    <div
      className="co-w-full co-flex co-gap-8px co-py-16px co-justify-center lg:co-justify-start lg:co-p-8px lg:co-gap-32px"
      tabIndex={0}
    >
      <Typography weight="bold" className="co-text-[#1A1A1A]">
        Compra 100% segura
      </Typography>
      <div className="co-flex co-gap-8px lg:co-gap-16px co-items-center">
        <img
          src={LogoCyberSource}
          alt={'LogoCyberSoure'}
          className="co-w-[38px] co-h-[23px]"
        />
        <img
          src={LogoGlobalSign}
          alt={'LogoGlobalSign'}
          width={57}
          height={22}
        />
        <img src={LogoSSL} alt={'LogoSSL'} width={24} height={24} />
      </div>
    </div>
  );
};
